import { CryptoPayoutStatus } from 'types/cryptoPayout';

import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'pages.cryptoPayout.cryptoPayoutInfo';

const LABELS = makeLabels(
  {
    HEADER: ['header', 'Payout Events'],
    STATUSES: {
      [CryptoPayoutStatus.Initiated]: ['status.initiated', 'Initiated'],
      [CryptoPayoutStatus.Pending]: ['status.pending', 'Customer Opened Refund Form'],
      [CryptoPayoutStatus.Submitted]: ['status.submitted', 'Submitted'],
      [CryptoPayoutStatus.Confirmed]: ['status.confirmed', 'Confirmed'],
      [CryptoPayoutStatus.Completed]: ['status.completed', 'Completed'],
      [CryptoPayoutStatus.Failed]: ['status.failed', 'Failed'],
      [CryptoPayoutStatus.Canceled]: ['status.rejected', 'Cancelled'],
    },
    STATUS_SUBMITTED_ONCHAIN: ['status.submittedOnchain', 'Submitted - {{asset}} onchain'],
    STATUS_SUBMITTED_BINANCE_PAY: ['status.submittedBinancePay', 'Submitted - {{asset}} via Binance Pay'],
    STATUS_CONFIRMED_AWAITING: ['status.confirmedAwaitingConfirmations', 'Confirmed - awaiting blockchain confirmations'],
  },
  NAMESPACE,
);

export const KEYS = {
  PREVIEW_STATUSES: [CryptoPayoutStatus.Initiated, CryptoPayoutStatus.Pending, CryptoPayoutStatus.Submitted, CryptoPayoutStatus.Confirmed],
  FAILED_STATUSES: [CryptoPayoutStatus.Failed, CryptoPayoutStatus.Canceled],
} as const;

export default LABELS;
